var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"jessibuca-player-container"},[_c('div',{ref:"videoDom",staticClass:"jessibuca-dom"})])
}
var staticRenderFns = []

export { render, staticRenderFns }